import z from "zod";

const MetaSchema = z.object({
  path: z.string(),
  tracerId: z.string(),
  duration: z.string(),
  method: z.string(),
});
export type metaSchemaType = z.infer<typeof MetaSchema>;

export default MetaSchema;
